<template lang="pug">
.uploader-wrapper
  file-pond(
    name="files",
    ref="pond",
    label-idle="Laden Sie Bilder hier hoch (maximal 10 auf einmal)",
    :allow-multiple="true",
    accepted-file-types="image/jpeg, image/png",
    v-model="files",
    :maxFiles="10"
    v-on:init="handleFilePondInit")
  b-button(
    type="is-light",
    @click="uploadImages()",
    :disabled="files.length <= 0 || loading") Bilder hochladen
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    FilePond,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return { files: [], loading: false };
  },
  methods: {
    handleFilePondInit: function () {
      // weiß nicht ob wir das benötigen
    },
    async uploadImages() {
      this.loading = true;
      const loadingComponent = this.$buefy.loading.open();
      const rawFiles = this.$refs.pond.getFiles();
      let files = [];
      for (let i = 0; i < rawFiles.length; i += 1) {
        files.push(rawFiles[i].file);
      }
      await this.$store.dispatch("rentObjectGroundplanImages/create", {
        id: this.id,
        files,
      });
      await this.$store.dispatch("rentObjectGroundplanImages/findAll", {
        id: this.id,
      });
      this.$emit("fileUploaded");
      this.$refs.pond.removeFiles();
      this.files = [];
      this.loading = false;
      loadingComponent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>